import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const useI18nUrls = () => {
  const { i18n } = useTranslation()
  const [termsUrl, setTermsUrl] = useState<string>('https://raund.net/terms/?no_layout=true')
  const [faqUrl, setFaqUrl] = useState<string>('https://raund.net/user_qa/')
  const [faqArCameraUrl, setFaqArCameraUrl] = useState<string>('https://raund.net/user_qa/ar_camera/')
  const [privacyPolicyUrl, setPrivaciyPolicyUrl] = useState<string>('https://raund.net/privacy/')

  const updateUrls = () => {
    if (i18n.language === 'ja_JP') {
      setTermsUrl('https://raund.net/terms/?no_layout=true')
      setFaqUrl('https://raund.net/user_qa/')
      setFaqArCameraUrl('https://raund.net/user_qa/ar_camera/')
      setPrivaciyPolicyUrl('https://raund.net/privacy/')
    } else if (i18n.language === 'en_US') {
      setTermsUrl('https://raund.net/en/terms-en/')
      setFaqUrl('https://raund.net/en/user_qa/')
      setFaqArCameraUrl('https://raund.net/en/user_qa/ar-camera/')
      setPrivaciyPolicyUrl('https://raund.net/en/privacy-en/')
    } else {
      setTermsUrl('https://raund.net/en/terms-en/')
      setFaqUrl('https://raund.net/en/user_qa/')
      setFaqArCameraUrl('https://raund.net/en/user_qa/ar-camera/')
      setPrivaciyPolicyUrl('https://raund.net/en/privacy-en/')
    }
  }
  useEffect(() => {
    updateUrls()
  }, [i18n.resolvedLanguage])
  return { termsUrl, faqUrl, faqArCameraUrl, privacyPolicyUrl }
}
